(function () {
  var CURRENCY_CODE = 'USD';
  var CURRENCY_SYMBOL = '$'; // đổi thành '$ ' nếu muốn có khoảng trắng: "$ 36.00"
  var SCOPE = '.tl__cart-goal__container__drawer';
  // "36.00USD", "1,234.00 USD" -> "$36.00", "$1,234.00"
  var AMOUNT_RE = new RegExp('(\\d+(?:[.,\\s\']\\d+)*)\\s?' + CURRENCY_CODE + '\\b', 'g');

  // Luôn hiển thị giá trị + tiêu đề milestone (không cần hover)
  var CSS = [
    '.tl__cart-goal__container__drawer .tl__cart-goal__goal-check-point__drawer > p,',
    '.tl__cart-goal__container__drawer .tl__cart-goal__goal-container__drawer:hover .tl__cart-goal__goal-check-point__drawer p,',
    '.tl__cart-goal__container__drawer[data-sew-skin="editorial"] .pnode .pabove,',
    '.tl__cart-goal__container__drawer[data-sew-skin="editorial"] .pnode .pbelow {',
    '  visibility: visible !important;',
    '  opacity: 1 !important;',
    '}'
  ].join('\n');

  function injectStyle() {
    if (document.getElementById('tl-progress-bar-tweak-style')) return;
    var style = document.createElement('style');
    style.id = 'tl-progress-bar-tweak-style';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function fixText(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (text.indexOf(CURRENCY_CODE) === -1) continue;
      // Dùng function: nếu dùng chuỗi thay thế, "$$1" sẽ bị hiểu thành chữ "$1"
      var next = text.replace(AMOUNT_RE, function (_, amount) {
        return CURRENCY_SYMBOL + amount;
      });
      if (next !== text) node.nodeValue = next;
    }
  }

  function run() {
    document.querySelectorAll(SCOPE).forEach(fixText);
  }

  // Widget render lại mỗi khi giỏ hàng thay đổi -> theo dõi DOM để áp dụng lại
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  });

  function start() {
    injectStyle();
    run();
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
